{
  "by_sacc_code": {
    "1101": "Australia (1101)",
    "1102": "Norfolk Island (1102)",
    "1201": "New Zealand (1201)",
    "1301": "New Caledonia (1301)",
    "1302": "Papua New Guinea (1302)",
    "1303": "Solomon Islands (1303)",
    "1304": "Vanuatu (1304)",
    "1401": "Guam (1401)",
    "1402": "Kiribati (1402)",
    "1403": "Marshall Islands (1403)",
    "1404": "Micronesia, Federated States of (1404)",
    "1405": "Nauru (1405)",
    "1406": "Northern Mariana Islands (1406)",
    "1407": "Palau (1407)",
    "1501": "Cook Islands (1501)",
    "1502": "Fiji (1502)",
    "1503": "French Polynesia (1503)",
    "1504": "Niue (1504)",
    "1505": "Samoa (1505)",
    "1506": "Samoa, American (1506)",
    "1507": "Tokelau (1507)",
    "1508": "Tonga (1508)",
    "1511": "Tuvalu (1511)",
    "1512": "Wallis and Futuna (1512)",
    "1513": "Pitcairn Islands (1513)",
    "1601": "Adelie Land (France) (1601)",
    "1602": "Argentinian Antarctic Territory (1602)",
    "1603": "Australian Antarctic Territory (1603)",
    "1604": "British Antarctic Territory (1604)",
    "1605": "Chilean Antarctic Territory (1605)",
    "1606": "Queen Maud Land (Norway) (1606)",
    "1607": "Ross Dependency (New Zealand) (1607)",
    "2102": "England (2102)",
    "2103": "Isle of Man (2103)",
    "2104": "Northern Ireland (2104)",
    "2105": "Scotland (2105)",
    "2106": "Wales (2106)",
    "2107": "Guernsey (2107)",
    "2108": "Jersey (2108)",
    "2201": "Ireland (2201)",
    "2301": "Austria (2301)",
    "2302": "Belgium (2302)",
    "2303": "France (2303)",
    "2304": "Germany (2304)",
    "2305": "Liechtenstein (2305)",
    "2306": "Luxembourg (2306)",
    "2307": "Monaco (2307)",
    "2308": "Netherlands (2308)",
    "2311": "Switzerland (2311)",
    "2401": "Denmark (2401)",
    "2402": "Faroe Islands (2402)",
    "2403": "Finland (2403)",
    "2404": "Greenland (2404)",
    "2405": "Iceland (2405)",
    "2406": "Norway (2406)",
    "2407": "Sweden (2407)",
    "2408": "Aland Islands (2408)",
    "3101": "Andorra (3101)",
    "3102": "Gibraltar (3102)",
    "3103": "Holy See (3103)",
    "3104": "Italy (3104)",
    "3105": "Malta (3105)",
    "3106": "Portugal (3106)",
    "3107": "San Marino (3107)",
    "3108": "Spain (3108)",
    "3201": "Albania (3201)",
    "3202": "Bosnia and Herzegovina (3202)",
    "3203": "Bulgaria (3203)",
    "3204": "Croatia (3204)",
    "3205": "Cyprus (3205)",
    "3206": "North Macedonia (3206)",
    "3207": "Greece (3207)",
    "3208": "Moldova (3208)",
    "3211": "Romania (3211)",
    "3212": "Slovenia (3212)",
    "3214": "Montenegro (3214)",
    "3215": "Serbia (3215)",
    "3216": "Kosovo (3216)",
    "3301": "Belarus (3301)",
    "3302": "Czechia (3302)",
    "3303": "Estonia (3303)",
    "3304": "Hungary (3304)",
    "3305": "Latvia (3305)",
    "3306": "Lithuania (3306)",
    "3307": "Poland (3307)",
    "3308": "Russian Federation (3308)",
    "3311": "Slovakia (3311)",
    "3312": "Ukraine (3312)",
    "4101": "Algeria (4101)",
    "4102": "Egypt (4102)",
    "4103": "Libya (4103)",
    "4104": "Morocco (4104)",
    "4105": "Sudan (4105)",
    "4106": "Tunisia (4106)",
    "4107": "Western Sahara (4107)",
    "4108": "Spanish North Africa (4108)",
    "4111": "South Sudan (4111)",
    "4201": "Bahrain (4201)",
    "4202": "Gaza Strip and West Bank (4202)",
    "4203": "Iran (4203)",
    "4204": "Iraq (4204)",
    "4205": "Israel (4205)",
    "4206": "Jordan (4206)",
    "4207": "Kuwait (4207)",
    "4208": "Lebanon (4208)",
    "4211": "Oman (4211)",
    "4212": "Qatar (4212)",
    "4213": "Saudi Arabia (4213)",
    "4214": "Syria (4214)",
    "4215": "Türkiye (4215)",
    "4216": "United Arab Emirates (4216)",
    "4217": "Yemen (4217)",
    "5101": "Myanmar (5101)",
    "5102": "Cambodia (5102)",
    "5103": "Laos (5103)",
    "5104": "Thailand (5104)",
    "5105": "Vietnam (5105)",
    "5201": "Brunei Darussalam (5201)",
    "5202": "Indonesia (5202)",
    "5203": "Malaysia (5203)",
    "5204": "Philippines (5204)",
    "5205": "Singapore (5205)",
    "5206": "Timor-Leste (5206)",
    "6101": "China (excludes SARs and Taiwan) (6101)",
    "6102": "Hong Kong (SAR of China) (6102)",
    "6103": "Macau (SAR of China) (6103)",
    "6104": "Mongolia (6104)",
    "6105": "Taiwan (6105)",
    "6201": "Japan (6201)",
    "6202": "Korea, Democratic People's Republic of (North) (6202)",
    "6203": "Korea, Republic of (South) (6203)",
    "7101": "Bangladesh (7101)",
    "7102": "Bhutan (7102)",
    "7103": "India (7103)",
    "7104": "Maldives (7104)",
    "7105": "Nepal (7105)",
    "7106": "Pakistan (7106)",
    "7107": "Sri Lanka (7107)",
    "7201": "Afghanistan (7201)",
    "7202": "Armenia (7202)",
    "7203": "Azerbaijan (7203)",
    "7204": "Georgia (7204)",
    "7205": "Kazakhstan (7205)",
    "7206": "Kyrgyzstan (7206)",
    "7207": "Tajikistan (7207)",
    "7208": "Turkmenistan (7208)",
    "7211": "Uzbekistan (7211)",
    "8101": "Bermuda (8101)",
    "8102": "Canada (8102)",
    "8103": "St Pierre and Miquelon (8103)",
    "8104": "United States of America (8104)",
    "8201": "Argentina (8201)",
    "8202": "Bolivia (8202)",
    "8203": "Brazil (8203)",
    "8204": "Chile (8204)",
    "8205": "Colombia (8205)",
    "8206": "Ecuador (8206)",
    "8207": "Falkland Islands (8207)",
    "8208": "French Guiana (8208)",
    "8211": "Guyana (8211)",
    "8212": "Paraguay (8212)",
    "8213": "Peru (8213)",
    "8214": "Suriname (8214)",
    "8215": "Uruguay (8215)",
    "8216": "Venezuela (8216)",
    "8301": "Belize (8301)",
    "8302": "Costa Rica (8302)",
    "8303": "El Salvador (8303)",
    "8304": "Guatemala (8304)",
    "8305": "Honduras (8305)",
    "8306": "Mexico (8306)",
    "8307": "Nicaragua (8307)",
    "8308": "Panama (8308)",
    "8401": "Anguilla (8401)",
    "8402": "Antigua and Barbuda (8402)",
    "8403": "Aruba (8403)",
    "8404": "Bahamas (8404)",
    "8405": "Barbados (8405)",
    "8406": "Cayman Islands (8406)",
    "8407": "Cuba (8407)",
    "8408": "Dominica (8408)",
    "8411": "Dominican Republic (8411)",
    "8412": "Grenada (8412)",
    "8413": "Guadeloupe (8413)",
    "8414": "Haiti (8414)",
    "8415": "Jamaica (8415)",
    "8416": "Martinique (8416)",
    "8417": "Montserrat (8417)",
    "8421": "Puerto Rico (8421)",
    "8422": "St Kitts and Nevis (8422)",
    "8423": "St Lucia (8423)",
    "8424": "St Vincent and the Grenadines (8424)",
    "8425": "Trinidad and Tobago (8425)",
    "8426": "Turks and Caicos Islands (8426)",
    "8427": "Virgin Islands, British (8427)",
    "8428": "Virgin Islands, United States (8428)",
    "8431": "St Barthelemy (8431)",
    "8432": "St Martin (French part) (8432)",
    "8433": "Bonaire, Sint Eustatius and Saba (8433)",
    "8434": "Curacao (8434)",
    "8435": "Sint Maarten (Dutch part) (8435)",
    "9101": "Benin (9101)",
    "9102": "Burkina Faso (9102)",
    "9103": "Cameroon (9103)",
    "9104": "Cabo Verde (9104)",
    "9105": "Central African Republic (9105)",
    "9106": "Chad (9106)",
    "9107": "Congo, Republic of (9107)",
    "9108": "Congo, Democratic Republic of (9108)",
    "9111": "Cote d'Ivoire (9111)",
    "9112": "Equatorial Guinea (9112)",
    "9113": "Gabon (9113)",
    "9114": "Gambia (9114)",
    "9115": "Ghana (9115)",
    "9116": "Guinea (9116)",
    "9117": "Guinea-Bissau (9117)",
    "9118": "Liberia (9118)",
    "9121": "Mali (9121)",
    "9122": "Mauritania (9122)",
    "9123": "Niger (9123)",
    "9124": "Nigeria (9124)",
    "9125": "Sao Tome and Principe (9125)",
    "9126": "Senegal (9126)",
    "9127": "Sierra Leone (9127)",
    "9128": "Togo (9128)",
    "9201": "Angola (9201)",
    "9202": "Botswana (9202)",
    "9203": "Burundi (9203)",
    "9204": "Comoros (9204)",
    "9205": "Djibouti (9205)",
    "9206": "Eritrea (9206)",
    "9207": "Ethiopia (9207)",
    "9208": "Kenya (9208)",
    "9211": "Lesotho (9211)",
    "9212": "Madagascar (9212)",
    "9213": "Malawi (9213)",
    "9214": "Mauritius (9214)",
    "9215": "Mayotte (9215)",
    "9216": "Mozambique (9216)",
    "9217": "Namibia (9217)",
    "9218": "Reunion (9218)",
    "9221": "Rwanda (9221)",
    "9222": "St Helena (9222)",
    "9223": "Seychelles (9223)",
    "9224": "Somalia (9224)",
    "9225": "South Africa (9225)",
    "9226": "Eswatini (9226)",
    "9227": "Tanzania (9227)",
    "9228": "Uganda (9228)",
    "9231": "Zambia (9231)",
    "9232": "Zimbabwe (9232)"
  }
}
